import { Component , OnInit} from '@angular/core';
import { DatosService } from '../servicios/datos.service';



@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})

export class SliderComponent implements OnInit {

  constructor(
    public _datosService : DatosService
  ){}

  ngOnInit(){}

  message = 0

  quotes  = this._datosService.quotes

  siguiente(){
    this.message++
    if( this.message == this.quotes.length ){
      this.message = 0
    }
  }

  anterior(){
    if( this.message == 0 ){
      this.message = this.quotes.length
    } 
    this.message--
  }

  establecer(i){
    this.message = i
  }

}
